import Web3 from 'web3'
class WalletState {
  wallet = {
    chainId: null,
    account: null,
    lang: 'Ch',
  }

  config = {
    //testnet
    // Token: '0xf8487cfC511bB7095878CeC685d676230bd7bC3B',
    // USDT: '0x82f78e165fa158494e84309a6496641A798B6C42',
    // Piece: '0xC46F66A0688E697ea61B158A07704e3418b40779',
    // Router: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    // Mint: "0x5212BC998Cb5914DFcc1cFB2D085D3A4f92C79da",
    // NFT: "0x944fEC228e4151cA104ED7C41d01260E4c05C14b",
    // NamiNFT: "0xB024D859656211CE7ACCAE98656Ee413B136CF26",
    // RightsMedal: '0x61E5D305a2363DE7f5A37E0a625D23363761ab71',
    //bsc
    //代币合约地址
    Token: '0xfa5B8323B462013cf2F7Eb5503A1D68cA4271111',
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    Piece: '0xF263cC32caED261A819713f3Dcc494A96c3e5111',
    Router: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    Mint: '0xd9023e8A776014288984d9fd0388960294dd5f51',
    // ---- merge NFT contract address
    NFT: '0x8f01E03c748565B71a4F494D368bD4220fe9476f',
    NamiNFT: '0x11bF9379Bc194de62D2800f4ad9b98096AC0c749',
    RightsMedal:'0x7F96471dd447B0be9Fe25bF8A94F5010C5E08888',
  }

  listeners = []

  constructor() {
    this.subcripeWeb3()
    this.getConfig()
  }
  //listen the wallet event
  async subcripeWeb3() {
    let page = this
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', function (accounts) {
        page.connetWallet()
        console.log('accountsChanged', accounts)
      })
      window.ethereum.on('chainChanged', function (chainId) {
        page.connetWallet()
        page.getConfig()
        console.log('chainChanged', chainId)
      })
    }
    // window.ethereum.on('connect', (connectInfo) => { });
    // window.ethereum.on('disconnect', (err) => { });
    // window.ethereum.isConnected();

    //         4001
    // The request was rejected by the user
    // -32602
    // The parameters were invalid
    // -32603
    // Internal error
  }

  async getConfig() {
    if (!Web3.givenProvider) {
      console.log('not wallet found')
    }

    var storage = window.localStorage
    if (storage) {
      var lang = storage['language']
      if (lang) {
        this.wallet.lang = lang
      }
    }
    console.log('config', this.config)
    console.log('wallet', this.wallet)
    this.notifyAll()
  }

  async connetWallet() {
    let provider = Web3.givenProvider || window.ethereum
    console.log('provider', provider)
    if (provider) {
      Web3.givenProvider = provider
      const web3 = new Web3(provider)
      const chainId = await web3.eth.getChainId()
      console.log(chainId)
      this.wallet.chainId = chainId
      const accounts = await web3.eth.requestAccounts()
      console.log('accounts')
      console.log(accounts)
      this.wallet.account = accounts[0]
      //测试
      //this.wallet.account = "0xbeC7C42cF8c9CA9716342343edD9677f1741226F";
      //this.wallet.account = "0xF7f63765D11B32076C2e019b9962cBA8819A5D84";
      this.notifyAll()
    } else {
      setTimeout(() => {
        this.connetWallet()
      }, 3000)
    }
  }

  onStateChanged(cb) {
    this.listeners.push(cb)
    cb()
  }

  removeListener(cb) {
    this.listeners = this.listeners.filter((item) => item !== cb)
  }

  notifyAll() {
    for (let i = 0; i < this.listeners.length; i++) {
      const cb = this.listeners[i]
      cb()
    }
  }
}
//测试链
//chain ID：97
//rpc：https://data-seed-prebsc-1-s1.bnbchain.org:8545/
//符号：tBNB
//浏览器：https://testnet.bscscan.com/
//领测试币，领取的地址要有正式网的bnb：https://www.bnbchain.org/en/testnet-faucet
//测试U：0x82f78e165fa158494e84309a6496641A798B6C42
//博饼交易所：https://pancakeswap.finance/?chain=bsctestnet

// export const CHAIN_ID = 97
// export const CHAIN_SYMBOL = "tBNB"
// export const CHAIN_ERROR_TIP = "请连接币安测试链钱包使用"

export const CHAIN_ID = 56
export const CHAIN_SYMBOL = 'BNB'
export const CHAIN_ERROR_TIP = 'connect bsc pls'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_INT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'
export default new WalletState()
